module.exports = __webpack_public_path__ + "img/727.3e1ea1e8.jpg";